import { appIntl } from '@nxsys/helpers/Common';
import {
  PaginationType,
} from '@nxsys/types/models/Common';
import { showToast } from '@nxsys/utils/toast';
import { createSlice } from '@reduxjs/toolkit';
import { exportActs } from '../action';
import { GetCompanyToExportParams, GetExportListParams, IExport } from '../types';

export interface ExportState {
  exportList: {
    loading: boolean;
    list: IExport[];
    pagination: PaginationType;
    queryParams: GetExportListParams | null;
  };
  companyList: {
    loading: boolean;
    list: any[];
    pagination: PaginationType;
    queryParams: GetCompanyToExportParams | null;
  };
}

const initialState: ExportState = {
  exportList: {
    loading: false,
    list: [],
    pagination: {
      current: 1,
      pageSize: 20,
      totalDocs: 0,
    },
    queryParams: null,
  },
  companyList: {
    loading: false,
    list: [],
    pagination: {
      current: 1,
      pageSize: 20,
      totalDocs: 0,
    },
    queryParams: null,
  },
};

const exportSlice = createSlice({
  name: 'export',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // Get Export Records
    builder.addCase(exportActs.getExportList.pending, (state) => {
      state.exportList.loading = true;
    });
    builder.addCase(exportActs.getExportList.fulfilled, (state, action) => {
      state.exportList.loading = false;
      state.exportList.list = action.payload.data;
      state.exportList.pagination = action.payload.pagination;
      state.exportList.queryParams = (action.payload as any).queryParams;
    });
    builder.addCase(exportActs.getExportList.rejected, (state, action) => {
      state.exportList.loading = false;
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.response?.data?.message ||
          appIntl().formatMessage({ id: 'export.getError' }),
      });
    });

    // Get Company Records To Export
    builder.addCase(exportActs.getCompanyToExport.pending, (state) => {
      state.companyList.loading = true;
    });
    builder.addCase(exportActs.getCompanyToExport.fulfilled, (state, action) => {
      state.companyList.loading = false;
      state.companyList.list = action.payload.data;
      state.companyList.pagination = action.payload.pagination;
      state.companyList.queryParams = (action.payload as any).queryParams;
    });
    builder.addCase(exportActs.getCompanyToExport.rejected, (state, action) => {
      state.companyList.loading = false;
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.response?.data?.message ||
          appIntl().formatMessage({ id: 'export.company.getError' }),
      });
    });

    // Export Company
    builder.addCase(exportActs.exportCompany.pending, () => {
    });
    builder.addCase(exportActs.exportCompany.fulfilled, (state, action) => {
      console.info('state', state);
      showToast({
        type: 'success',
        message: action.payload.data?.message,
      });
    });
    builder.addCase(exportActs.exportCompany.rejected, (state, action) => {
      console.info('state', state);
      showToast({
        type: 'error',
        message:
          (action.payload as any)?.response?.data?.message ||
          appIntl().formatMessage({ id: 'export.company.exportError' }),
      });
    });
  },
});

export const exportReducer = exportSlice.reducer;
export const exportActions = {
  ...exportSlice.actions,
  ...exportActs,
};
